import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const SALE_STATUS_APPROVAL = {
  title: 'Estado Aprobación',
  tooltip: 'Estado de aprobación del préstamo',
  tooltipId: 'sale-status-approval',
};

export const SALE_STATUS_SETTLEMENT = {
  title: 'Estado Liquidación',
  tooltip: 'Estado del pago al comercio',
  tooltipId: 'sale-status-settlement',
};

function SaleStatusLabelWithTooltip({
  title,
  tooltipText,
  tooltipId,
  htmlFor,
  className = 'sale-status-col-header sale-status-col-header--has-tooltip',
}) {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={tooltipId} className="text-wrap">
          {tooltipText}
        </Tooltip>
      }
    >
      <span className={className} tabIndex={0} aria-label={tooltipText}>
        <span className="sale-status-col-header__title">{title}</span>
      </span>
    </OverlayTrigger>
  );
}

function SaleStatusColumnHeader({ title, tooltipText, tooltipId, className = '' }) {
  return (
    <th className={className}>
      <SaleStatusLabelWithTooltip
        title={title}
        tooltipText={tooltipText}
        tooltipId={tooltipId}
      />
    </th>
  );
}

export function ApprovalStatusColumnHeader(props) {
  return (
    <SaleStatusColumnHeader
      title={SALE_STATUS_APPROVAL.title}
      tooltipText={SALE_STATUS_APPROVAL.tooltip}
      tooltipId={SALE_STATUS_APPROVAL.tooltipId}
      {...props}
    />
  );
}

export function SettlementStatusColumnHeader(props) {
  return (
    <SaleStatusColumnHeader
      title={SALE_STATUS_SETTLEMENT.title}
      tooltipText={SALE_STATUS_SETTLEMENT.tooltip}
      tooltipId={SALE_STATUS_SETTLEMENT.tooltipId}
      {...props}
    />
  );
}

export function ApprovalStatusFilterLabel({ htmlFor, className = 'form-label sales-filters-card__label' }) {
  return (
    <label htmlFor={htmlFor} className={className}>
      <SaleStatusLabelWithTooltip
        title={SALE_STATUS_APPROVAL.title}
        tooltipText={SALE_STATUS_APPROVAL.tooltip}
        tooltipId={`${SALE_STATUS_APPROVAL.tooltipId}-filter`}
      />
    </label>
  );
}

export function SettlementStatusFilterLabel({ htmlFor, className = 'form-label sales-filters-card__label' }) {
  return (
    <label htmlFor={htmlFor} className={className}>
      <SaleStatusLabelWithTooltip
        title={SALE_STATUS_SETTLEMENT.title}
        tooltipText={SALE_STATUS_SETTLEMENT.tooltip}
        tooltipId={`${SALE_STATUS_SETTLEMENT.tooltipId}-filter`}
      />
    </label>
  );
}
